module.exports = __webpack_public_path__ + "static/jacks-lighthouse-0e26eaacdc28a37597e1804e123510ab.jpg";